import { useQueryClient } from '@tanstack/react-query';
import { useShareComponentEntryMutation, getComponentEntryQueryKey } from '@utils/component-framework';

const useShareEntryMutation = () => {
  const queryClient = useQueryClient();
  const updateComponentEntry = useShareComponentEntryMutation();
  return entryKey => {
    const entry = queryClient.getQueryData(getComponentEntryQueryKey(entryKey));
    updateComponentEntry.mutate({
      entry,
      message: undefined
    });
  };
};

export { useShareEntryMutation };
//# sourceMappingURL=share-entry.js.map
